import { createAction, props } from '@ngrx/store';
import { Template } from 'src/app/models/template.model';

export const loadTemplates = createAction('[Repository] Load Templates');

export const loadTemplatesSuccess = createAction(
    '[Repository] Load Templates Success',
    props<{ templates: Template[] }>()
);
